import { useSyncExternalStore } from "react";
import {
	getSession,
	isAuthenticated as readIsAuthenticated,
	subscribeAuth,
} from "@/features/auth/lib/auth-store";
import { canRedeem } from "@/features/auth/lib/can-redeem";

export function useAuth() {
	const session = useSyncExternalStore(subscribeAuth, getSession, () => null);
	return {
		session,
		isAuthenticated: Boolean(session?.accessToken && session?.refreshToken),
		canRedeem: canRedeem(session),
	};
}

export function useIsAuthenticated(): boolean {
	return useSyncExternalStore(subscribeAuth, readIsAuthenticated, () => false);
}
